import Rx from "rxjs";
import { EpicFactory } from "../../../../core/core-redux/reduxTypes";
import { doNothingAction } from "../../../../common/action/doNothingAction";
import {
    BASELINE_LAYER_GROUP,
    wfs3dBaselineLayerSelector,
    wfs3dWorkspaceLayerSelector,
    WORKSPACE_LAYER_GROUP,
} from "../../../../common/selector/layerSelector";
import EnvParamsRetriever from "../../../../common/util/EnvParamsRetriever";
import { CHANGE_MAP_CRS, ChangeMapCrs } from "../../../../common/mapstore/action";
import { Action } from "redux";
import { Layer, RootState } from "../../../../rootState";
import { fromActionCreator } from "../../../../core/core-rx/types";
import { getFeatureCountActions } from "../../../api/getFeatureCount.reduxActions";
import { Projection } from "../../../../common/types";
import { storeWfsFeatureCountAction } from "./storeWfsFeatureCount.action";
import { setWfs3dLayerCountAction } from "./setWfs3dLayerCount.action";

export const wfs3dLayerCountEpic: EpicFactory<Action, RootState, Action> = (action$, store) =>
    action$
        .ofType<ChangeMapCrs>(CHANGE_MAP_CRS)
        .filter((action) => action.crs === Projection.GLOBE_3D)
        .switchMap(() => {
            const state = store.getState();
            const workspaceWfsLayers = wfs3dWorkspaceLayerSelector(state);
            const baselineWfsLayers = wfs3dBaselineLayerSelector(state);

            const allLayers: any[] = [];

            baselineWfsLayers.forEach((layer: Layer) => allLayers.push({ group: BASELINE_LAYER_GROUP, layer: layer }));
            workspaceWfsLayers.forEach((layer: Layer) =>
                allLayers.push({ group: WORKSPACE_LAYER_GROUP, layer: layer })
            );

            if (allLayers.length > 0) {
                return Rx.Observable.from(allLayers)
                    .mergeMap((layerDefinition) => {
                        const layerGroup = layerDefinition.group;
                        const wfs3dLayerName = layerDefinition.layer.wfs3dLayer;
                        const environmentParams =
                            layerGroup === BASELINE_LAYER_GROUP
                                ? EnvParamsRetriever.getBaselineEnvParams(state)
                                : EnvParamsRetriever.getWorkspaceEnvParams(state);
                        const params = {
                            typeName: layerDefinition.layer.wfs3dLayer,
                            ENV: environmentParams.toRequestParams(),
                            resultType: "hits",
                        };

                        return fromActionCreator(getFeatureCountActions, params).map((data) => {
                            if (data.response !== undefined) {
                                return storeWfsFeatureCountAction(layerGroup, wfs3dLayerName, data.response);
                            }
                            return doNothingAction();
                        });
                    })
                    .startWith(
                        setWfs3dLayerCountAction(BASELINE_LAYER_GROUP, baselineWfsLayers.length),
                        setWfs3dLayerCountAction(WORKSPACE_LAYER_GROUP, workspaceWfsLayers.length)
                    );
            }
            return [doNothingAction()];
        });
